<template>
  <v-container fluid class="pa-0">
    <v-card elevation="0">
      <v-card-title> Overview Dashboard </v-card-title>
      <v-card-text>
        <cash-flow-chart></cash-flow-chart>
      </v-card-text>
    </v-card>
    <h2 class="pa-3"></h2>
  </v-container>
</template>
<script>
import CashFlowChart from "@/components/CashFlowChart.vue";

export default {
  components: {
    "cash-flow-chart": CashFlowChart,
  },
};
</script>
